import {
  CREATE_ROOM_FAILURE,
  CREATE_ROOM_REQUEST,
  CREATE_ROOM_SUCCESS,
  CreateRoomFailureAction,
  CreateRoomRequestAction,
  CreateRoomSuccessAction,
  DELETE_ROOM_FAILURE,
  DELETE_ROOM_REQUEST,
  DELETE_ROOM_SUCCESS,
  DeleteRoomFailureAction,
  DeleteRoomRequestAction,
  DeleteRoomSuccessAction,
  FETCH_ROOMS_FAILURE,
  FETCH_ROOMS_REQUEST,
  FETCH_ROOMS_SUCCESS,
  FetchRoomsFailureAction,
  FetchRoomsRequestAction,
  FetchRoomsSuccessAction,
  Room,
  RoomActionTypes,
  UPDATE_SELECTED_ROOM,
  UpdateSelectedRoomAction,
} from '@/types'
import { apiUrl } from '@services/environment'
import axios from 'axios'
import { Dispatch } from 'react'

export const fetchRoomsRequest = (): FetchRoomsRequestAction => ({
  type: FETCH_ROOMS_REQUEST,
  payload: null,
})

export const fetchRoomsSuccess = (rooms: Room[]): FetchRoomsSuccessAction => ({
  type: FETCH_ROOMS_SUCCESS,
  payload: rooms,
})

export const fetchRoomsFailure = (error: string): FetchRoomsFailureAction => ({
  type: FETCH_ROOMS_FAILURE,
  payload: error,
})

export const updateSelectedRoom = (
  roomId: string | null
): UpdateSelectedRoomAction => ({
  type: UPDATE_SELECTED_ROOM,
  payload: roomId,
})

export const createRoomRequest = (): CreateRoomRequestAction => ({
  type: CREATE_ROOM_REQUEST,
  payload: null,
})

export const createRoomSuccess = (room: Room): CreateRoomSuccessAction => ({
  type: CREATE_ROOM_SUCCESS,
  payload: room,
})

export const createRoomFailure = (error: string): CreateRoomFailureAction => ({
  type: CREATE_ROOM_FAILURE,
  payload: error,
})

export const deleteRoomRequest = (): DeleteRoomRequestAction => ({
  type: DELETE_ROOM_REQUEST,
  payload: null,
})

export const deleteRoomSuccess = (roomID: string): DeleteRoomSuccessAction => ({
  type: DELETE_ROOM_SUCCESS,
  payload: roomID,
})

export const deleteRoomFailure = (error: string): DeleteRoomFailureAction => ({
  type: DELETE_ROOM_FAILURE,
  payload: error,
})

export const fetchRooms = (channelID: string) => {
  return async (dispatch: Dispatch<RoomActionTypes>) => {
    dispatch(fetchRoomsRequest())
    try {
      const response = await axios.get(apiUrl + `Channel/${channelID}/rooms`, {
        withCredentials: true,
      })
      const data = response.data
      dispatch(fetchRoomsSuccess(data.rooms))
    } catch (error: any) {
      dispatch(fetchRoomsFailure(error.message))
    }
  }
}

export const createRoom = (room: Room) => {
  return async (dispatch: Dispatch<RoomActionTypes>) => {
    dispatch(createRoomRequest())
    try {
      const response = await axios.post(apiUrl + `Room`, room, {
        withCredentials: true,
      })
      const data = response.data
      dispatch(createRoomSuccess(data))
    } catch (error: any) {
      dispatch(createRoomFailure(error.message))
    }
  }
}

export const deleteRoom = (roomID: string) => {
  return async (dispatch: Dispatch<RoomActionTypes>) => {
    dispatch(deleteRoomRequest())
    try {
      await axios.delete(apiUrl + `Room/${roomID}`, {
        withCredentials: true,
      })
      dispatch(deleteRoomSuccess(roomID))
    } catch (error: any) {
      dispatch(deleteRoomFailure(error.message))
    }
  }
}
